/**
 * AssetScanService
 * RFID/QR/barcode scan-to-find + entrance/movement scan logging.
 */
import { BaseService } from '../base/BaseService';
/** Service for the asset scan endpoints (/api/asset-scan/*). */
export class AssetScanService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? AssetScanService.DEFAULT_SERVICE_PATH,
            basePath: AssetScanService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    /** Resolve a scanned code to an asset (scan-to-find) and log the scan. */
    async resolve(req) {
        const response = await this.resolveRaw(req);
        if (!response.data)
            throw new Error('Failed to resolve scan');
        return response.data;
    }
    resolveRaw(req) {
        return this.http.post(this.buildUrl('resolve'), req);
    }
    /** Log an entrance/movement scan (e.g. from a fixed-reader bridge). */
    async scan(req) {
        const response = await this.scanRaw(req);
        if (!response.data)
            throw new Error('Failed to log scan');
        return response.data;
    }
    scanRaw(req) {
        return this.http.post(this.buildUrl('scan'), req);
    }
    /** Scan/movement history for an asset. */
    async history(assetId) {
        const response = await this.historyRaw(assetId);
        return response.data ?? [];
    }
    historyRaw(assetId) {
        return this.http.get(this.buildUrl(`${assetId}/history`));
    }
}
AssetScanService.DEFAULT_SERVICE_PATH = 'assetmanagement';
AssetScanService.BASE_PATH = 'api/asset-scan';
//# sourceMappingURL=AssetScanService.js.map